export const normalizeAssignedTo = (value) =>
  String(value || "").trim().toLowerCase();

export const validateAssignedTo = (value, { required = false } = {}) => {
  const normalized = normalizeAssignedTo(value);

  if (required && !normalized) {
    return "Please select an agent.";
  }

  if (normalized.length > 255) {
    return "assignedTo length cannot exceed 255 characters";
  }

  return "";
};

export const validateNote = (value) => {
  const note = String(value || "").trim();
  if (note.length > 500) {
    return "note length cannot exceed 500 characters";
  }
  return "";
};
